import QuizBox from './QuizBox';
import { ChoiceBox, Radio, ActionBox, QuizBoxView } from './QuizBox.view';
import QuizContentWrapper from './QuizContentWrapper';
import QuizDivider from './QuizDivider';
import QuizLayoutWrapper from './QuizLayoutWrapper';
import QuizFooterWrapper from './QuizFooterWrapper';

export {
  ChoiceBox,
  Radio,
  ActionBox,
  QuizBoxView,
  QuizContentWrapper,
  QuizDivider,
  QuizLayoutWrapper,
  QuizFooterWrapper,
};
export default QuizBox;
